var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dt__video"},[_c('div',{ref:"video",staticClass:"dt__video-container"}),(_vm.showUserIcon)?_c('user-icon',{attrs:{"profile":_vm.userProfile}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }